export const ISalesItem = {
  id: 260,
  store_id: 115,
  kind: 0,
  is_asap: true,
  preorder_for: '2000-01-01T00:00:00.000Z',
  status: 'pending',
  status_pos: 'pending',
  order_type: 2,
  partner_id: 1,
  created_at: '2024-04-26T14:27:18.194Z',
  customer_name: 'Sam Smith',
  customer_contact_number: '+447702219932',
  eta_pickup: '2024-04-26T14:30:12.000Z',
  delivery_tracking_url: '',
  order_id_ordering_partner: '',
  order_type_enum: 'delivery',
}

export const ISalesItemView = {
  id: 327,
  store_id: 115,
  is_asap: true,
  customer_name: 'Tech S.',
  customer_contact_number: '+441388436844',
  customer_email: '',
  preorder_for: '2000-01-01T00:00:00.000Z',
  total: 7.47,
  basket_total: 1.69,
  discount: 0,
  delivery: 2.79,
  tax: 0,
  service_charge: 0.99,
  tip: 0,
  small_order_fee: 2,
  refund: 0,
  delivery_discount: 0,
  flat_fee: 0,
  transaction_fee: 0,
  total_items: 0,
  status: 'ready_to_collect',
  status_pos: 'pending',
  note: '',
  delivery_partner: '',
  delivery_address_line1: '',
  delivery_address_line2: '',
  delivery_address_city: '',
  delivery_address_postcode: '',
  delivery_address_country: '',
  delivery_tracking_id: '',
  order_type: 2,
  points_count: 0,
  prep_minutes: 15,
  delivery_address_note: '',
  driver_name: '',
  driver_contact_number: '',
  delivery_tracking_url: '',
  cancellation_reason: '',
  eta_pickup: '2024-05-07T17:24:15.000Z',
  eta_delivery: '2024-05-07T17:30:00.000Z',
  distance: 0,
  driver_requested: false,
  driver_requested_at: null,
  age_limit: false,
  delivery_partner_fee: 0,
  driver_req_delay_minutes: 0,
  created_at: '2024-05-07T17:08:47.323Z',
  updated_at: '2024-05-07T17:29:03.429Z',
  partner_id: 5,
  order_id_ordering_partner: '358a47b2-e82f-485a-a1e7-c5e923457706',
  order_type_enum: 'delivery',
  items: [
    {
      id: 516,
      name: 'Flat White',
      item_id: 64,
      type: 0,
      fee: 1.1,
      discount: 0,
      tax: 0,
      qty: 1,
      line_total: 0,
      parent_id: 0,
      modifiers: [
        {
          id: 517,
          name: 'Normal',
          item_id: 11,
          type: 0,
          fee: 0,
          discount: 0,
          tax: 0,
          qty: 1,
          line_total: 0,
          parent_id: 516,
        },
      ],
    },
  ],
  statuses: [
    {
      status: 'register',
      status_at: '2024-05-07T17:08:48.000Z',
    },
  ],
}

export const IPosSalesItem = {
  id: 676,
  name: 'Duracell D',
  sale_id: 417,
  item_id: 228,
  item_id2: '0',
  type: 0,
  fee: '4.500',
  discount: '0.000',
  tax: '0.000',
  qty: '1.000',
  line_total: '0.000',
  promocode: '',
  parent_id: 0,
  is_archive: false,
  last_user_id: 0,
  created_at: '2024-06-18T11:17:50.142Z',
  updated_at: '2024-06-18T11:17:50.142Z',
  archived_at: null,
  note: '',
}
